module.exports = __webpack_public_path__ + "static/media/buffet8.85c43a3d.jpg";